export const YEAR_RANGE_INITIAL_YEAR = 2020;
